import styled from 'styled-components';
import Form from 'components/form';
import _RegistrationSuccessModal from './components/registration-success-modal';
import { ReactComponent as GiftIcon } from 'styles/icons/gift-icon.svg';
import { typography, color } from 'styles/settings';

export const SubmitButton = styled(Form.SubmitButton)`
  font-size: ${typography.size.md};
`;

export const FormHalfWidthContainer = styled.div`
  display: flex;
  flex-direction: row;
  > div {
    width: 50%;

    @media all and (max-width: 768px) {
      width: 60%;
    }
    > div {
      width: calc(100% - 42px);
      > input {
        width: calc(100% - 42px);
      }
    }
  }

  > :nth-child(2) {
    > :first-child {
      margin-left: 10px;
    }
    > :nth-child(2) {
      margin-left: 10px;
    }
  }
`;

export const FormBottomContainer = styled.div`
  > :nth-child(1) > :nth-child(1) {
    width: auto;
  }

  > :nth-child(2) > :nth-child(1) {
    width: auto;
  }

  > :nth-child(3) > :nth-child(1) {
    width: auto;
  }
`;

export const SignInCodeGiftIcon = styled(GiftIcon)``;

export const OptionLink = styled.span`
  ${typography.font.semiBold};
  color: ${({ theme }) => theme.secondary};
`;

export const RegistrationSuccessModal = styled(_RegistrationSuccessModal)`
  width: 30%;
  max-width: 780px;
`;
